import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, Checkbox, Container, Form, FormField, Input, Multiselect, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { useColor } from "react-color-palette";
import "react-color-palette/css"; // Don't forget the CSS!
import Copy from '../../../../../components/Copy';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';

interface ModuleOption {
    value: string;
    label: string;
    description: string;
    type: string;
    tags?: string[];
    iconSvg?: React.ReactNode;
}

export const SystemSecurityAPIKeysEditPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [apikey, setApiKey] = useState<any>({});
    const { navigate } = useRouter();
    const { menu, idAirport } = useGlobalState();
    const [color, setColor] = useColor("#1273de");

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const timer = setTimeout(() => {
            navigate('system/security/apikeys.edit?id=0')
        }, 500);
        return () => clearTimeout(timer);
    }, [idAirport]);
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id)
                handleGetApiKey(parseInt(id));
            else {
                setApiKey({});
                //window.location.hash = "#config/displays";
            }
            //handleGetEmail(id ? parseInt(id) : 0);
            //else
            //setMailTemplate(undefined);
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);
    useEffect(() => {

    }, []);


    const handleUpdateApiKey = async () => { // Make the function async

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/security/apikeys/update',
                },
                body: JSON.stringify(apikey),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                addNotification(dataWeb.status, "success", setData);
                window.location.hash = "#system/security/apikeys";
            } else {
                addNotification(dataWeb.status, "error", setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    };
    const handleGetApiKey = async (id: number) => { // Make the function async
        setData((prev: any) => {
            const newData = { ...prev, notifications: [] };
            localStorage.setItem("data", JSON.stringify(newData));
            return newData;
        });

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/security/apikeys/get',
                },
                body: JSON.stringify({ idApiKey: id }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                if (dataWeb.apikey === null) {
                    navigate('system/security/apikeys');
                    return;
                }
                setApiKey(dataWeb.apikey);
            } else {
                addNotification(dataWeb.status, "error", setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }

    };

    const optionsModule: ModuleOption[] = [
        { value: '/v7/routing/api/sicns/publish/', label: '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\Ingreso de hora de despliegue de vuelo', description: "\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\/routing/api/sicns/publish/", type: "SICNS", iconSvg: <BadgeCustom color='lime'>SICNS</BadgeCustom> },
        { value: '/v7/routing/api/sicns/report/', label: '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\Reporte de hora de despliegue de vuelo', description: "\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\/routing/api/sicns/report/", type: "SICNS", iconSvg: <BadgeCustom color='lime'>SICNS</BadgeCustom> },
        { value: '/v7/routing/api/rms/publish/', label: '\u00a0\u00a0\u00a0\u00a0\u00a0Endpoint para ingreso de información de vuelos', description: "\u00a0\u00a0\u00a0\u00a0\u00a0/routing/api/rms/publish/", type: "RMS", iconSvg: <BadgeCustom color='purple'>RMS</BadgeCustom> },
        { value: '/v7/routing/api/json/flights/', label: '\u00a0\u00a0\u00a0\u00a0\u00a0Listado de vuelos', description: "\u00a0\u00a0\u00a0\u00a0\u00a0/routing/api/json/flights/", type: "JSON", iconSvg: <BadgeCustom color='blue'>JSON</BadgeCustom> },
    ]


    // 2. Read the type directly from your config

    const getSelectedOptions = (ids: string[], source: ModuleOption[]) =>
        source.filter((s) => ids.includes(s.value));
    const selectedOptions = getSelectedOptions(apikey?.jsonRoutings || [], optionsModule);

    // 3. Handle change: extract only the values to save to state
    const handleRoutingChange = (newSelectedOptions: readonly ModuleOption[]) => {
        const newIds = newSelectedOptions.map(o => o.value);
        setApiKey({
            ...apikey!,
            jsonRoutings: newIds
        });
    };
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>{`ApiKey ${apikey ? apikey.idApiKey : ''}`}</Header>

                    {apikey && (


                        <div style={{ maxWidth: 700 }}>
                            <Form
                                actions={
                                    <SpaceBetween size="m" direction='horizontal'>
                                        <Button variant="link" onClick={() => { window.location.hash = "#system/security/apikeys"; }}>Cancelar</Button>
                                        <Button variant="primary" onClick={() => {
                                            handleUpdateApiKey();
                                        }}>Actualizar</Button>
                                    </SpaceBetween>}>

                                <SpaceBetween size="m" direction='vertical'>


                                    <div style={{ width: 400 }}>
                                        <FormField label="Descripción">
                                            <Input value={apikey.description} onChange={e => {
                                                setApiKey({ ...apikey, description: e.detail.value });
                                            }} />
                                        </FormField>
                                    </div>
                                    <FormField label="Estado">
                                        <Checkbox checked={apikey.isActive} onChange={e => {
                                            setApiKey({ ...apikey, isActive: e.detail.checked });
                                        }}> Activo</Checkbox>
                                    </FormField>

                                    <div style={{ maxWidth: 600 }}>
                                        <FormField label="Rutas habilitadas"

                                        >
                                            <Multiselect
                                                options={optionsModule}
                                                // Cloudscape needs the full objects that match the items in optionsModule
                                                selectedOptions={getSelectedOptions(apikey?.jsonRoutings || [], optionsModule)}
                                                onChange={({ detail }) => handleRoutingChange(detail.selectedOptions as ModuleOption[])}

                                                placeholder={selectedOptions.length == 0 ? "Seleccionar rutas" : `${selectedOptions.length}/${optionsModule.length} rutas seleccionadas`}
                                            />
                                        </FormField>
                                    </div>
                                    <Container>
                                        <FormField label="Api Key">
                                            <SpaceBetween size="xs" direction='horizontal'>
                                                <Box>{apikey.apiKey}</Box>
                                                <Box><Copy text='API key copiada al portapapeles' value={apikey.apiKey} /></Box>
                                            </SpaceBetween>
                                        </FormField>
                                    </Container>
                                </SpaceBetween>
                            </Form>
                        </div>
                    )}

                </SpaceBetween>
            }
        />
    )
};


{/* Disabled for now
                  <div style={{ padding: "20px", maxWidth: "300px" }}>
                    <h3>Select Theme Color</h3>

                    <ColorPicker
                      color={color}
                      onChange={setColor}
                      hideInput={["rgb", "hsv", "rgb"]} // Simplifies the UI for users
                    />

                    <div style={{ marginTop: "20px" }}>
                      <p>Selected Hex: <strong>{color.hex}</strong></p>
                      <div style={{
                        width: "100%",
                        height: "40px",
                        backgroundColor: color.hex,
                        borderRadius: "4px",
                        border: "1px solid #ccc"
                      }} />
                    </div>
                  </div>
                  {/* Disabled for now */}